// Profile.jsx
import React from "react";
//import userImage from "../../assets/images/user.png"; // Adjust the import path as needed

const Settings = () => {
  return (
    <div className="w-full bg-white p-6 rounded-lg shadow-lg">
     <p>Today</p>
    </div>
  );
};

export default Settings;
